import {createAsyncThunk} from "@reduxjs/toolkit";
import {useHttp} from "../../hooks/http.hook";


export const fetchVideosInfo = createAsyncThunk(
    'videosInfo/fetchVideosInfo',
    async (query) => {
        const {request} = useHttp();
        const dataLang = localStorage.getItem('dataLang');
        const shortNameParam = dataLang ? `?lang=${JSON.parse(dataLang).shortName}` : '';
        let url = `api/videos/${window.env.PROJECT_ID}/list/${shortNameParam}`;

        if (query.hasOwnProperty('categoryId')) {
            url += `&categoryId=${query.categoryId}`;
        }
        if (query.hasOwnProperty('top')) {
            url += `&top=${query.top}`;
        }
        if (query.hasOwnProperty('skip')) {
            url += `&skip=${query.skip}`;
        }

        const {json} = await request(url, 'GET', null, null, false);
        return await new Promise((resolve) => resolve(json));
    }
);
